__turbopack_context__.v({
  "thumbnail": "_2rYm9W_thumbnail",
  "videocontainer": "_2rYm9W_videocontainer",
  "videoinnercontainer": "_2rYm9W_videoinnercontainer",
});
